
import { Record } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { lambda_type, unit_type, record_type, bool_type, class_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { createContext } from "react";
import React from "react";
import * as react from "react";

export class DateTimeSettings extends Record {
    constructor(TimeZoneOffset, UseLocalTime) {
        super();
        this.TimeZoneOffset = TimeZoneOffset;
        this.UseLocalTime = UseLocalTime;
    }
}

export function DateTimeSettings_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Components.TimeZones.Context.DateTimeSettings", [], DateTimeSettings, () => [["TimeZoneOffset", class_type("System.TimeSpan")], ["UseLocalTime", bool_type]]);
}

export class TimezoneContext extends Record {
    constructor(Settings, SetSettings) {
        super();
        this.Settings = Settings;
        this.SetSettings = SetSettings;
    }
}

export function TimezoneContext_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Components.TimeZones.Context.TimezoneContext", [], TimezoneContext, () => [["Settings", DateTimeSettings_$reflection()], ["SetSettings", lambda_type(DateTimeSettings_$reflection(), unit_type)]]);
}

export const dateTimeSettings = new DateTimeSettings(0, false);

export const defaultContext = new TimezoneContext(dateTimeSettings, (_arg) => {
});

export const timeZoneContext = createContext(defaultContext);

export function TimeZoneContext($props) {
    const children = $props.children;
    const ctx = $props.ctx;
    return react.createElement(timeZoneContext.Provider, {
        value: ctx,
    }, children);
}

